import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  role?: 'dialog' | 'alertdialog';
  ariaLabel?: string;
}

export function Modal({
  isOpen,
  onClose,
  children,
  className,
  role = 'dialog',
  ariaLabel
}: ModalProps) {
  if (!isOpen || typeof document === 'undefined') {
    return null;
  }

  const contentClassName = ['auth-terms-modal', className].filter(Boolean).join(' ');

  return createPortal(
    <div
      className="auth-terms-modal-backdrop"
      role="presentation"
      onClick={onClose}
    >
      <div
        className={contentClassName}
        role={role}
        aria-modal="true"
        aria-label={ariaLabel}
        onClick={(event) => event.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
